var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{staticClass:"sub-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("\n    确定\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }